import AdminLayout from '../layouts/admin/Layout';
import PublicLayout from '../layouts/public/Layout';

import DashboardPage from '../pages/admin/dashboard/DashboardPage';
import LoginPage from '../pages/admin/access/LoginPage';
import ProfilePage from '../pages/admin/account/ProfilePage';
import PasswordPage from '../pages/admin/account/PasswordPage';
import AccountPage from '../pages/admin/account/AccountPage';

import AdministratorsPage from '../pages/admin/users/administrators/AdministratorsPage';
import AdministratorNewPage from '../pages/admin/users/administrators/AdministratorNewPage';
import AdministratorUpdatePage from '../pages/admin/users/administrators/AdministratorUpdatePage';
import AdministratorViewPage from '../pages/admin/users/administrators/AdministratorViewPage';

import CustomersPage from '../pages/admin/users/customers/CustomersPage';
import CustomerNewPage from '../pages/admin/users/customers/CustomerNewPage';
import CustomerUpdatePage from '../pages/admin/users/customers/CustomerUpdatePage';
import CustomerViewPage from '../pages/admin/users/customers/CustomerViewPage';

import DriversPage from '../pages/admin/users/drivers/DriversPage';
import DriverNewPage from '../pages/admin/users/drivers/DriverNewPage';
import DriverUpdatePage from '../pages/admin/users/drivers/DriverUpdatePage';
import DriverViewPage from '../pages/admin/users/drivers/DriverViewPage';

import WorkersPage from '../pages/admin/users/workers/WorkersPage';
import WorkerNewPage from '../pages/admin/users/workers/WorkerNewPage';
import WorkerUpdatePage from '../pages/admin/users/workers/WorkerUpdatePage';
import WorkerViewPage from '../pages/admin/users/workers/WorkerViewPage';

// import MembersPage from '../pages/admin/users/members/MembersPage';
// import MemberNewPage from '../pages/admin/users/members/MemberNewPage';
// import MemberUpdatePage from '../pages/admin/users/members/MemberUpdatePage';

import SuppliersPage from '../pages/admin/users/suppliers/SuppliersPage';
import SupplierNewPage from '../pages/admin/users/suppliers/SupplierNewPage';
import SupplierUpdatePage from '../pages/admin/users/suppliers/SupplierUpdatePage';
import SupplierViewPage from '../pages/admin/users/suppliers/SupplierViewPage';

import RetailersPage from '../pages/admin/users/retailers/RetailersPage';
import RetailerNewPage from '../pages/admin/users/retailers/RetailerNewPage';
import RetailerUpdatePage from '../pages/admin/users/retailers/RetailerUpdatePage';
import RetailerViewPage from '../pages/admin/users/retailers/RetailerViewPage';

// import OutletMembersPage from
// '../pages/admin/users/retailers/unuse/retail_members/OutletMembersPage';
// import OutletMemberNewPage from
// '../pages/admin/users/retailers/unuse/retail_members/OutletMemberNewPage';
// import OutletMemberUpdatePage from
// '../pages/admin/users/retailers/unuse/retail_members/OutletMemberUpdatePage';

import CategoriesPage from '../pages/admin/products/categories/CategoriesPage';
import CategoryNewPage from '../pages/admin/products/categories/CategoryNewPage';
import CategoryUpdatePage from '../pages/admin/products/categories/CategoryUpdatePage';
import BrandPage from '../pages/admin/products/brands/BrandPage';
import BrandNewPage from '../pages/admin/products/brands/BrandNewPage';
import BrandUpdatePage from '../pages/admin/products/brands/BrandUpdatePage';
import UomPage from '../pages/admin/products/uoms/UomPage';
import UomNewPage from '../pages/admin/products/uoms/UomNewPage';
import UomUpdatePage from '../pages/admin/products/uoms/UomUpdatePage';

import ProductsPage from '../pages/admin/products/products/ProductsPage';
import ProductUpdatePage from '../pages/admin/products/products/ProductUpdatePage';
import ProductNewPage from '../pages/admin/products/products/ProductNewPage';
import ProductViewPage from '../pages/admin/products/products/ProductViewPage';

import CountriesPage from '../pages/admin/settings/region/country/CountriesPage';
import CountryUpdatePage from '../pages/admin/settings/region/country/CountryUpdatePage';

import SalesOrdersPage from '../pages/admin/documents/sales_orders/SalesOrdersPage';
import SalesOrderNewPage from '../pages/admin/documents/sales_orders/SalesOrderNewPage';
import SalesOrderViewPage from '../pages/admin/documents/sales_orders/SalesOrderViewPage';
import SalesOrderUpdatePage from '../pages/admin/documents/sales_orders/SalesOrderUpdatePage';

import ProformaSalesPage from '../pages/admin/documents/proforma_sales/ProformaSalesPage';
import ProformaSalesNewPage from '../pages/admin/documents/proforma_sales/ProformaSalesNewPage';
import ProformaSalesUpdatePage from '../pages/admin/documents/proforma_sales/ProformaSalesUpdatePage';
import ProformaSalesViewPage from '../pages/admin/documents/proforma_sales/ProformaSalesViewPage';

import PurchaseOrdersPage from '../pages/admin/documents/purchase_orders/PurchaseOrdersPage';
import PurchaseOrderNewPage from '../pages/admin/documents/purchase_orders/PurchaseOrderNewPage';
import PurchaseOrderViewPage from '../pages/admin/documents/purchase_orders/PurchaseOrderViewPage';
import PurchaseOrderUpdatePage from '../pages/admin/documents/purchase_orders/PurchaseOrderUpdatePage';

import CashSalesPage from '../pages/admin/documents/cash_sales/CashSalesPage';
import CashSalesNewPage from '../pages/admin/documents/cash_sales/CashSalesNewPage';
import CashSalesViewPage from '../pages/admin/documents/cash_sales/CashSalesViewPage';
import CashSalesVerifyQutPage from '../pages/admin/documents/cash_sales/CashSalesVerifyOutPage';

import RetailCashSalesNewPage from '../pages/admin/documents/retail_cash_sales/RetailCashSalesNewPage';
import RetailCashSalesPage from '../pages/admin/documents/retail_cash_sales/RetailCashSalesPage';
import RetailCashSalesStockPostPage from '../pages/admin/documents/retail_cash_sales/RetailCashSalesStockPostPage';
import RetailCashSalesViewPage from '../pages/admin/documents/retail_cash_sales/RetailCashSalesViewPage';

import DeliveryOrdersPage from '../pages/admin/documents/delivery_orders/DeliveryOrdersPage';
import DeliveryOrderNewPage from '../pages/admin/documents/delivery_orders/DeliveryOrderNewPage';
import DeliveryOrderUpdatePage from '../pages/admin/documents/delivery_orders/DeliveryOrderUpdatePage';
import DeliveryOrderViewPage from '../pages/admin/documents/delivery_orders/DeliveryOrderViewPage';
import DeliveryOrderVerifyQutPage from '../pages/admin/documents/delivery_orders/DeliveryOrderVerifyOutPage';

import TripOrdersPage from '../pages/admin/documents/trip_orders/TripOrdersPage';
import TripOrderNewPage from '../pages/admin/documents/trip_orders/TripOrderNewPage';
import TripOrderUpdatePage from '../pages/admin/documents/trip_orders/TripOrderUpdatePage';
import TripOrderViewPage from '../pages/admin/documents/trip_orders/TripOrderViewPage';

import PickOrdersPage from '../pages/admin/documents/pick_orders/PickOrdersPage';
import PickOrderNewPage from '../pages/admin/documents/pick_orders/PickOrderNewPage';
import PickOrderUpdatePage from '../pages/admin/documents/pick_orders/PickOrderUpdatePage';
import PickOrderViewPage from '../pages/admin/documents/pick_orders/PickOrderViewPage';

import PackingOrdersPage from '../pages/admin/documents/packing_orders/PackingOrdersPage';
import PackingOrderViewPage from '../pages/admin/documents/packing_orders/PackingOrderViewPage';

// import ItemPickingsPage from
// '../pages/admin/documents/item_pickings/ItemPickingsPage';

import ItemReceivesPage from '../pages/admin/documents/item_receives/ItemReceivesPage';
import ItemReceiveNewPage from '../pages/admin/documents/item_receives/ItemReceiveNewPage';
import ItemReceiveUpdatePage from '../pages/admin/documents/item_receives/ItemReceiveUpdatePage';
import ItemReceiveViewPage from '../pages/admin/documents/item_receives/ItemReceiveViewPage';
import ItemReceiveVerifyInPage from '../pages/admin/documents/item_receives/ItemReceiveVerifyInPage';

import ItemTransfersPage from '../pages/admin/documents/item_transfers/ItemTransfersPage';
import ItemTransferNewPage from '../pages/admin/documents/item_transfers/ItemTransferNewPage';
import ItemTransferUpdatePage from '../pages/admin/documents/item_transfers/ItemTransferUpdatePage';
import ItemTransferViewPage from '../pages/admin/documents/item_transfers/ItemTransferViewPage';
import ItemTransferVerifyTransferInPage from '../pages/admin/documents/item_transfers/ItemTransferVerifyTransferInPage';
import ItemTransferVerifyOutPage from '../pages/admin/documents/item_transfers/ItemTransferVerifyOutPage';

// import ItemRepacksPage from
// '../pages/admin/documents/item_repacks/ItemRepacksPage';

import RetailPrescriptionNewPage from '../pages/admin/documents/retail_prescriptions/RetailPrescriptionNewPage';
import RetailPrescriptionsPage from '../pages/admin/documents/retail_prescriptions/RetailPrescriptionsPage';
import RetailPrescriptionViewPage from '../pages/admin/documents/retail_prescriptions/RetailPrescriptionViewPage';
import RetailPrescriptionUpdatePage from '../pages/admin/documents/retail_prescriptions/RetailPrescriptionUpdatePage';

import AdministratorGroupsPage from '../pages/admin/groups/administrators/AdministratorGroupsPage';
import AdministratorGroupNewPage from '../pages/admin/groups/administrators/AdministratorGroupNewPage';
import AdministratorGroupUpdatePage from '../pages/admin/groups/administrators/AdministratorGroupUpdatePage';
import CustomerGroupsPage from '../pages/admin/groups/customers/CustomerGroupsPage';
import CustomerGroupNewPage from '../pages/admin/groups/customers/CustomerGroupNewPage';
import CustomerGroupUpdatePage from '../pages/admin/groups/customers/CustomerGroupUpdatePage';
import SupplierGroupsPage from '../pages/admin/groups/suppliers/SupplierGroupsPage';
import SupplierGroupNewPage from '../pages/admin/groups/suppliers/SupplierGroupNewPage';
import SupplierGroupUpdatePage from '../pages/admin/groups/suppliers/SupplierGroupUpdatePage';

import ContainersPage from '../pages/admin/repositories/containers/ContainersPage';
import ContainerNewPage from '../pages/admin/repositories/containers/ContainerNewPage';
import ContainerUpdatePage from '../pages/admin/repositories/containers/ContainerUpdatePage';

import PackagesPage from '../pages/admin/repositories/packages/PackagesPage';
import PackageNewPage from '../pages/admin/repositories/packages/PackageNewPage';
import PackagePackPage from '../pages/admin/repositories/packages/PackagePackPage';
import PackageViewPage from '../pages/admin/repositories/packages/PackageViewPage';

import TransportersPage from '../pages/admin/logistics/TransportersPage';
import TransporterNewPage from '../pages/admin/logistics/TransporterNewPage';
import TransporterUpdatePage from '../pages/admin/logistics/TransporterUpdatePage';

import SalesDebitNotesPage from '../pages/admin/documents/sales_debit_notes/SalesDebitNotesPage';
import SalesDebitNoteNewPage from '../pages/admin/documents/sales_debit_notes/SalesDebitNoteNewPage';
import SalesDebitNoteUpdatePage from '../pages/admin/documents/sales_debit_notes/SalesDebitNoteUpdatePage';
import SalesDebitNoteViewPage from '../pages/admin/documents/sales_debit_notes/SalesDebitNoteViewPage';
import SalesDebitNoteVerifyOutPage from '../pages/admin/documents/sales_debit_notes/SalesDebitNoteVerifyOutPage';

import PurchaseReturnsPage from '../pages/admin/documents/purchase_returns/PurchaseReturnsPage';
import PurchaseReturnNewPage from '../pages/admin/documents/purchase_returns/PurchaseReturnNewPage';
import PurchaseReturnUpdatePage from '../pages/admin/documents/purchase_returns/PurchaseReturnUpdatePage';
import PurchaseReturnViewPage from '../pages/admin/documents/purchase_returns/PurchaseReturnViewPage';
import PurchaseReturnVerifyOutPage from '../pages/admin/documents/purchase_returns/PurchaseReturnVerifyOutPage';

import SalesCreditNotesPage from '../pages/admin/documents/sales_credit_notes/SalesCreditNotesPage';
import SalesCreditNoteNewPage from '../pages/admin/documents/sales_credit_notes/SalesCreditNoteNewPage';
import SalesCreditNoteUpdatePage from '../pages/admin/documents/sales_credit_notes/SalesCreditNoteUpdatePage';
import SalesCreditNoteViewPage from '../pages/admin/documents/sales_credit_notes/SalesCreditNoteViewPage';
import SalesCreditNoteVerifyInPage from '../pages/admin/documents/sales_credit_notes/SalesCreditNoteVerifyInPage';

import ReplacementDeliveriesPage from '../pages/admin/documents/replacement_delivery/ReplacementDeliveriesPage';
import ReplacementDeliveryNewPage from '../pages/admin/documents/replacement_delivery/ReplacementDeliveryNewPage';
import ReplacementDeliveryUpdatePage from '../pages/admin/documents/replacement_delivery/ReplacementDeliveryUpdatePage';
import ReplacementDeliveryViewPage from '../pages/admin/documents/replacement_delivery/ReplacementDeliveryViewPage';
import ReplacementDeliveryVerifyOutPage from '../pages/admin/documents/replacement_delivery/ReplacementDeliveryVerifyOutPage';

import ItemRelocatesPage from '../pages/admin/documents/item_relocates/ItemRelocatesPage';
import ItemRelocateNewPage from '../pages/admin/documents/item_relocates/ItemRelocateNewPage';
import ItemRelocateViewPage from '../pages/admin/documents/item_relocates/ItemRelocateViewPage';
import ItemRelocateUpdatePage from '../pages/admin/documents/item_relocates/ItemRelocateUpdatePage';

import ItemTransformPage from '../pages/admin/documents/item_transform/ItemTransformPage';
import ItemTransformNewPage from '../pages/admin/documents/item_transform/ItemTransformNewPage';
import ItemTransformViewPage from '../pages/admin/documents/item_transform/ItemTransformViewPage';

import PurchaseInvoicesPage from '../pages/admin/documents/purchase_invoices/PurchaseInvoicesPage';
import PurchaseInvoiceNewPage from '../pages/admin/documents/purchase_invoices/PurchaseInvoiceNewPage';
import PurchaseInvoiceUpdatePage from '../pages/admin/documents/purchase_invoices/PurchaseInvoiceUpdatePage';
import PurchaseInvoiceViewPage from '../pages/admin/documents/purchase_invoices/PurchaseInvoiceViewPage';

import ItemIssuesPage from '../pages/admin/documents/item_issues/ItemIssuesPage';
import ItemIssueNewPage from '../pages/admin/documents/item_issues/ItemIssueNewPage';
import ItemIssueUpdatePage from '../pages/admin/documents/item_issues/ItemIssueUpdatePage';
import ItemIssueViewPage from '../pages/admin/documents/item_issues/ItemIssueViewPage';
import ItemIssueVerifyQutPage from '../pages/admin/documents/item_issues/ItemIssueVerifyOutPage';

import ItemAdjustmentsPage from '../pages/admin/documents/item_adjustments/ItemAdjustmentsPage';
import ItemAdjustmentNewPage from '../pages/admin/documents/item_adjustments/ItemAdjustmentNewPage';
import ItemAdjustmentUpdatePage from '../pages/admin/documents/item_adjustments/ItemAdjustmentUpdatePage';
import ItemAdjustmentViewPage from '../pages/admin/documents/item_adjustments/ItemAdjustmentViewPage';
import ItemAdjustmentVerifyInPage from '../pages/admin/documents/item_adjustments/ItemAdjustmentVerifyInPage';
import ItemAdjustmentVerifyOutPage from '../pages/admin/documents/item_adjustments/ItemAdjustmentVerifyOutPage';

import StockTakesPage from '../pages/admin/documents/stock_takes/StockTakesPage';
import StockTakeNewPage from '../pages/admin/documents/stock_takes/StockTakeNewPage';
import StockTakeUpdatePage from '../pages/admin/documents/stock_takes/StockTakeUpdatePage';
import StockTakeViewPage from '../pages/admin/documents/stock_takes/StockTakeViewPage';
import StockTakeExecutePage from '../pages/admin/documents/stock_takes/StockTakeExecutePage';

import TransferReturnsPage from '../pages/admin/documents/transfer_returns/TransferReturnsPage';
import TransferReturnNewPage from '../pages/admin/documents/transfer_returns/TransferReturnNewPage';
import TransferReturnUpdatePage from '../pages/admin/documents/transfer_returns/TransferReturnUpdatePage';
import TransferReturnViewPage from '../pages/admin/documents/transfer_returns/TransferReturnViewPage';
import TransferReturnVerifyTransferInPage from '../pages/admin/documents/transfer_returns/TransferReturnVerifyTransferInPage';
import TransferReturnVerifyOutPage from '../pages/admin/documents/transfer_returns/TransferReturnVerifyOutPage';

import TransferRequisitionsPage from '../pages/admin/documents/transfer_requisitions/TransferRequisitionsPage';
import TransferRequisitionNewPage from '../pages/admin/documents/transfer_requisitions/TransferRequisitionNewPage';
import TransferRequisitionUpdatePage from '../pages/admin/documents/transfer_requisitions/TransferRequisitionUpdatePage';
import TransferRequisitionViewPage from '../pages/admin/documents/transfer_requisitions/TransferRequisitionViewPage';

import ViewInventoryPage from '../pages/admin/operations/inventory/ViewInventoryPage';
import ItemRelocateThresholdPage from '../pages/admin/operations/itemThreshold/ItemRelocateThresholdPage';
import ItemReorderThresholdPage from '../pages/admin/operations/itemThreshold/ItemReorderThresholdPage';

import SalesInvoicesPage from '../pages/admin/documents/sales_invoices/SalesInvoicesPage';
import SalesInvoiceNewPage from '../pages/admin/documents/sales_invoices/SalesInvoiceNewPage';
import SalesInvoiceUpdatePage from '../pages/admin/documents/sales_invoices/SalesInvoiceUpdatePage';
import SalesInvoiceViewPage from '../pages/admin/documents/sales_invoices/SalesInvoiceViewPage';

// import SalesReport from "../pages/admin/reports/SalesReport";
// import RetailCashSalesReport
//     from "../pages/admin/reports/RetailCashSalesReport";
// import DeliveryReport from "../pages/admin/reports/DeliveryReport";
// import RetailPrescriptionReport
//     from "../pages/admin/reports/RetailPrescriptionReport";
// import ItemReceiveReport from "../pages/admin/reports/ItemReceiveReport";

import ProductItemReport from '../pages/admin/reports/product/ProductItemReport';
import SalesOrderReport from '../pages/admin/reports/sales/SalesOrderReport';
import SalesOrderItemReport from '../pages/admin/reports/sales/SalesOrderItemReport';
import DeliveryOrderReport from '../pages/admin/reports/sales/DeliveryOrderReport';
import DeliveryOrderItemReport from '../pages/admin/reports/sales/DeliveryOrderItemReport';
import ItemReceiveReport from '../pages/admin/reports/warehouse/ItemReceiveReport';
import ItemReceiveItemReport from '../pages/admin/reports/warehouse/ItemReceiveItemReport';
import ItemTransferReport from '../pages/admin/reports/warehouse/ItemTransferReport';
import ItemTransferItemReport from '../pages/admin/reports/warehouse/ItemTransferItemReport';
import StockValueReport from '../pages/admin/reports/inventory/StockValueReport';

// import TasksPage from "../pages/admin/schedulers/tasks/TasksPage";
// import TaskNewPage from "../pages/admin/schedulers/tasks/TaskNewPage";
// import TaskUpdatePage from "../pages/admin/schedulers/tasks/TaskUpdatePage";

import TasksPage from '../pages/admin/settings/schedulers/tasks/TasksPage';
import TaskNewPage from '../pages/admin/settings/schedulers/tasks/TaskNewPage';
import TaskUpdatePage from '../pages/admin/settings/schedulers/tasks/TaskUpdatePage';

// import LogsPage from "../pages/admin/schedulers/logs/LogsPage";
// import LogViewPage from "../pages/admin/schedulers/logs/LogViewPage";

import LogsPage from '../pages/admin/settings/schedulers/logs/LogsPage';
import LogViewPage from '../pages/admin/settings/schedulers/logs/LogViewPage';

// import RequestsPage from "../pages/admin/schedulers/requests/RequestsPage";
// import RequestViewPage from "../pages/admin/schedulers/requests/RequestViewPage";

import RequestsPage from '../pages/admin/settings/schedulers/requests/RequestsPage';
import RequestViewPage from '../pages/admin/settings/schedulers/requests/RequestViewPage';

// import ConsolePage from "../pages/admin/schedulers/console/ConsolePage";

import ConsolePage from '../pages/admin/settings/schedulers/console/ConsolePage';

// Settings //
import SettingsPage from '../pages/admin/settings/SettingsPage';

import UserRolesPage from '../pages/admin/settings/user_roles/UserRolesPage';
import UserRoleNewPage from '../pages/admin/settings/user_roles/UserRoleNewPage';
import UserRoleUpdatePage from '../pages/admin/settings/user_roles/UserRoleUpdatePage';

import BusinessPage from '../pages/admin/settings/business/BusinessPage';
import BusinessNewPage from '../pages/admin/settings/business/BusinessNewPage';
import BusinessUpdatePage from '../pages/admin/settings/business/BusinessUpdatePage';

import LocationsPage from '../pages/admin/settings/location/LocationsPage';
import LocationNewPage from '../pages/admin/settings/location/LocationNewPage';
import LocationUpdatePage from '../pages/admin/settings/location/LocationUpdatePage';

import CustomFieldsPage from '../pages/admin/settings/customFields/CustomFieldsPage';
import CustomFieldNewPage from '../pages/admin/settings/customFields/CustomFieldNewPage';
import CustomFieldUpdatePage from '../pages/admin/settings/customFields/CustomFieldUpdatePage';

import ShippingRatesPage from '../pages/admin/settings/shipping_rates/ShippingRatesPage';
import ShippingRateNewPage from '../pages/admin/settings/shipping_rates/ShippingRateNewPage';
import ShippingRateUpdatePage from '../pages/admin/settings/shipping_rates/ShippingRateUpdatePage';
import ShippingRulesPage from '../pages/admin/settings/shipping_rules/ShippingRulesPage';
import ShippingRuleNewPage from '../pages/admin/settings/shipping_rules/ShippingRuleNewPage';
import ShippingRuleUpdatePage from '../pages/admin/settings/shipping_rules/ShippingRuleUpdatePage';

import TaxRateNewPage from '../pages/admin/settings/tax_rates/TaxRateNewPage';
import TaxRatesPage from '../pages/admin/settings/tax_rates/TaxRatesPage';
import TaxRateUpdatePage from '../pages/admin/settings/tax_rates/TaxRateUpdatePage';

import AuditTrailsPage from '../pages/admin/settings/audit_trails/AuditTrailsPage';
import AuditTrailNewPage from '../pages/admin/settings/audit_trails/AuditTrailNewPage';
import AuditTrailViewPage from '../pages/admin/settings/audit_trails/AuditTrailViewPage';
import AuditTrailTagsPage from '../pages/admin/settings/audit_trails/AuditTrailTagsPage';

import InjectionPropsPage from '../pages/admin/settings/injectionProps/InjectionPropsPage';
import InjectionPropNewPage from '../pages/admin/settings/injectionProps/InjectionPropNewPage';

import InjectionFieldsPage from '../pages/admin/settings/injectionFields/InjectionFieldsPage';
import InjectionFieldNewPage from '../pages/admin/settings/injectionFields/InjectionFieldNewPage';

import EmailGatewayPage from '../pages/admin/settings/email/EmailGatewayPage';
import WhatsAppPage from '../pages/admin/settings/whatsapp/WhatsAppPage';
import SMSPage from '../pages/admin/settings/sms/SMSPage';

import WalletsPage from '../pages/admin/settings/wallets/WalletsPage';
import WalletNewPage from '../pages/admin/settings/wallets/WalletNewPage';
import WalletUpdatePage from '../pages/admin/settings/wallets/WalletUpdatePage';
import WalletUsersPage from '../pages/admin/settings/wallets/WalletUsersPage';
// import WalletViewPage from '../pages/admin/settings/wallets/WalletViewPage';

import UserApiKeysPage from '../pages/admin/settings/userApiKeys/UserApiKeysPage';
import UserApiKeyNewPage from '../pages/admin/settings/userApiKeys/UserApiKeyNewPage';
import UserApiKeyUpdatePage from '../pages/admin/settings/userApiKeys/UserApiKeyUpdatePage';

// Settings //

// Settings //
import WalletRequestNewPage from '../pages/admin/transactions/wallet/WalletRequestNewPage';
import WalletRequestsPage from '../pages/admin/transactions/wallet/WalletRequestsPage';
import WalletRequestUpdatePage from '../pages/admin/transactions/wallet/WalletRequestUpdatePage';

import WalletTransactionsPage from '../pages/admin/transactions/wallet/WalletTransactionsPage';

export default function routes() {
  return [
    {
      path: '/admin',
      element: <PublicLayout />,
      children: [
        // { element: <Navigate to="dashboard" />, index: true },
        { path: 'login', element: <LoginPage /> },
      ],
    },
    {
      path: '/admin',
      element: <AdminLayout />,
      children: [
        // { element: <Navigate to="dashboard" />, index: true },
        { path: '', element: <DashboardPage /> },

        { path: 'dashboard', element: <DashboardPage /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'password', element: <PasswordPage /> },
        { path: 'account', element: <AccountPage /> },

        { path: 'users/administrators', element: <AdministratorsPage /> },
        { path: 'users/administrator/new', element: <AdministratorNewPage /> },
        { path: 'users/administrator/update/:id', element: <AdministratorUpdatePage /> },
        { path: 'users/administrator/view/:id', element: <AdministratorViewPage /> },
        { path: 'users/customers', element: <CustomersPage /> },
        { path: 'users/customer/new', element: <CustomerNewPage /> },
        { path: 'users/customer/update/:id', element: <CustomerUpdatePage /> },
        { path: 'users/customer/view/:id', element: <CustomerViewPage /> },
        { path: 'users/drivers', element: <DriversPage /> },
        { path: 'users/driver/new', element: <DriverNewPage /> },
        { path: 'users/driver/update/:id', element: <DriverUpdatePage /> },
        { path: 'users/driver/view/:id', element: <DriverViewPage /> },
        { path: 'users/workers', element: <WorkersPage /> },
        { path: 'users/worker/new', element: <WorkerNewPage /> },
        { path: 'users/worker/update/:id', element: <WorkerUpdatePage /> },
        { path: 'users/worker/view/:id', element: <WorkerViewPage /> },
        // { path: 'users/members', element: <MembersPage /> },
        // { path: 'users/member/new', element: <MemberNewPage /> },
        // { path: 'users/member/update/:id', element:
        // <MemberUpdatePage /> },
        { path: 'users/suppliers', element: <SuppliersPage /> },
        { path: 'users/supplier/new', element: <SupplierNewPage /> },
        { path: 'users/supplier/update/:id', element: <SupplierUpdatePage /> },
        { path: 'users/supplier/view/:id', element: <SupplierViewPage /> },
        { path: 'users/retailers', element: <RetailersPage /> },
        { path: 'users/retailer/new', element: <RetailerNewPage /> },
        { path: 'users/retailer/update/:id', element: <RetailerUpdatePage /> },
        { path: 'users/retailer/view/:id', element: <RetailerViewPage /> },

        // { path: 'users/retailer/:id/outletMembers', element:
        // <OutletMembersPage /> }, { path:
        // 'users/retailer/:id/outletMember/new', element:
        // <OutletMemberNewPage /> }, { path:
        // 'users/retailer/:retailerId/outletMember/update/:id',
        // element: <OutletMemberUpdatePage /> },

        { path: 'products/categories', element: <CategoriesPage /> },
        { path: 'products/category/new', element: <CategoryNewPage /> },
        { path: 'products/category/update/:id', element: <CategoryUpdatePage /> },
        { path: 'products/brands', element: <BrandPage /> },
        { path: 'products/brand/new', element: <BrandNewPage /> },
        { path: 'products/brand/update/:id', element: <BrandUpdatePage /> },
        { path: 'products/uoms', element: <UomPage /> },
        { path: 'products/uom/new', element: <UomNewPage /> },
        { path: 'products/uom/update/:id', element: <UomUpdatePage /> },
        { path: 'products/items', element: <ProductsPage /> },
        { path: 'product/item/new', element: <ProductNewPage /> },
        { path: 'product/item/view/:id', element: <ProductViewPage /> },
        { path: 'product/item/update/:id', element: <ProductUpdatePage /> },

        { path: 'documents/salesOrders', element: <SalesOrdersPage /> },
        { path: 'documents/salesOrder/new', element: <SalesOrderNewPage /> },
        { path: 'documents/salesOrder/view/:id', element: <SalesOrderViewPage /> },
        { path: 'documents/salesOrder/update/:id', element: <SalesOrderUpdatePage /> },

        { path: 'documents/proformaSales', element: <ProformaSalesPage /> },
        { path: 'documents/proformaSales/new', element: <ProformaSalesNewPage /> },
        { path: 'documents/proformaSales/update/:id', element: <ProformaSalesUpdatePage /> },
        { path: 'documents/proformaSales/view/:id', element: <ProformaSalesViewPage /> },

        { path: 'documents/purchaseOrders', element: <PurchaseOrdersPage /> },
        { path: 'documents/purchaseOrder/new', element: <PurchaseOrderNewPage /> },
        { path: 'documents/purchaseOrder/view/:id', element: <PurchaseOrderViewPage /> },
        { path: 'documents/purchaseOrder/update/:id', element: <PurchaseOrderUpdatePage /> },

        { path: 'documents/cashSales', element: <CashSalesPage /> },
        { path: 'documents/cashSales/new', element: <CashSalesNewPage /> },
        { path: 'documents/cashSales/view/:id', element: <CashSalesViewPage /> },
        // { path: 'documents/cashSales/stockPost/:id', element:
        // <CashSalesStockPostPage /> },
        { path: 'documents/cashSales/verifyOut/:id', element: <CashSalesVerifyQutPage /> },

        { path: 'documents/retailCashSales', element: <RetailCashSalesPage /> },
        { path: 'documents/retailCashSales/new', element: <RetailCashSalesNewPage /> },
        { path: 'documents/retailCashSales/stockPost/:id', element: <RetailCashSalesStockPostPage /> },
        { path: 'documents/retailCashSales/view/:id', element: <RetailCashSalesViewPage /> },

        // { path: 'documents/taxRate', element: <TaxRatePage /> },

        { path: 'documents/deliveryOrders', element: <DeliveryOrdersPage /> },
        { path: 'documents/deliveryOrder/new', element: <DeliveryOrderNewPage /> },
        { path: 'documents/deliveryOrder/update/:id', element: <DeliveryOrderUpdatePage /> },
        { path: 'documents/deliveryOrder/view/:id', element: <DeliveryOrderViewPage /> },
        { path: 'documents/deliveryOrder/verifyOut/:id', element: <DeliveryOrderVerifyQutPage /> },

        { path: 'documents/tripOrders', element: <TripOrdersPage /> },
        { path: 'documents/tripOrder/new', element: <TripOrderNewPage /> },
        { path: 'documents/tripOrder/update/:id', element: <TripOrderUpdatePage /> },
        { path: 'documents/tripOrder/view/:id', element: <TripOrderViewPage /> },

        { path: 'documents/pickOrders', element: <PickOrdersPage /> },
        { path: 'documents/pickOrder/new', element: <PickOrderNewPage /> },
        { path: 'documents/pickOrder/update/:id', element: <PickOrderUpdatePage /> },
        { path: 'documents/pickOrder/view/:id', element: <PickOrderViewPage /> },

        { path: 'documents/packingOrders', element: <PackingOrdersPage /> },
        { path: 'documents/packingOrder/view/:id', element: <PackingOrderViewPage /> },

        // { path: 'documents/itemPickings', element: <ItemPickingsPage
        // /> },

        { path: 'documents/itemReceives', element: <ItemReceivesPage /> },
        { path: 'documents/itemReceive/new', element: <ItemReceiveNewPage /> },
        { path: 'documents/itemReceive/update/:id', element: <ItemReceiveUpdatePage /> },
        { path: 'documents/itemReceive/view/:id', element: <ItemReceiveViewPage /> },
        { path: 'documents/itemReceive/verifyIn/:id', element: <ItemReceiveVerifyInPage /> },

        { path: 'documents/itemTransfers', element: <ItemTransfersPage /> },
        { path: 'documents/itemTransfer/new', element: <ItemTransferNewPage /> },
        { path: 'documents/itemTransfer/update/:id', element: <ItemTransferUpdatePage /> },
        { path: 'documents/itemTransfer/view/:id', element: <ItemTransferViewPage /> },
        { path: 'documents/itemTransfer/verifyTransferIn/:id', element: <ItemTransferVerifyTransferInPage /> },
        { path: 'documents/itemTransfer/verifyOut/:id', element: <ItemTransferVerifyOutPage /> },

        // { path: 'documents/itemRepacks', element: <ItemRepacksPage
        // /> },

        { path: 'documents/retailPrescriptions', element: <RetailPrescriptionsPage /> },
        { path: 'documents/retailPrescription/new', element: <RetailPrescriptionNewPage /> },
        { path: 'documents/retailPrescription/view/:id', element: <RetailPrescriptionViewPage /> },
        { path: 'documents/retailPrescription/update/:id', element: <RetailPrescriptionUpdatePage /> },

        { path: 'groups/administrators', element: <AdministratorGroupsPage /> },
        { path: 'groups/administrator/new', element: <AdministratorGroupNewPage /> },
        { path: 'groups/administrator/update/:id', element: <AdministratorGroupUpdatePage /> },
        { path: 'groups/customers', element: <CustomerGroupsPage /> },
        { path: 'groups/customer/new', element: <CustomerGroupNewPage /> },
        { path: 'groups/customer/update/:id', element: <CustomerGroupUpdatePage /> },
        { path: 'groups/suppliers', element: <SupplierGroupsPage /> },
        { path: 'groups/supplier/new', element: <SupplierGroupNewPage /> },
        { path: 'groups/supplier/update/:id', element: <SupplierGroupUpdatePage /> },

        { path: 'repositories/containers', element: <ContainersPage /> },
        { path: 'repositories/container/new', element: <ContainerNewPage /> },
        { path: 'repositories/container/update/:id', element: <ContainerUpdatePage /> },

        { path: 'repositories/packages', element: <PackagesPage /> },
        { path: 'repositories/package/new', element: <PackageNewPage /> },
        { path: 'repositories/package/pack', element: <PackagePackPage /> },
        { path: 'repositories/package/view', element: <PackageViewPage /> },

        { path: 'logistics/transporters', element: <TransportersPage /> },
        { path: 'logistics/transporter/new', element: <TransporterNewPage /> },
        { path: 'logistics/transporter/update/:id', element: <TransporterUpdatePage /> },

        { path: 'documents/salesDebitNotes', element: <SalesDebitNotesPage /> },
        { path: 'documents/salesDebitNote/new', element: <SalesDebitNoteNewPage /> },
        { path: 'documents/salesDebitNote/update/:id', element: <SalesDebitNoteUpdatePage /> },
        { path: 'documents/salesDebitNote/view/:id', element: <SalesDebitNoteViewPage /> },
        { path: 'documents/salesDebitNote/verifyOut/:id', element: <SalesDebitNoteVerifyOutPage /> },

        { path: 'documents/purchaseReturns', element: <PurchaseReturnsPage /> },
        { path: 'documents/purchaseReturn/new', element: <PurchaseReturnNewPage /> },
        { path: 'documents/purchaseReturn/update/:id', element: <PurchaseReturnUpdatePage /> },
        { path: 'documents/purchaseReturn/view/:id', element: <PurchaseReturnViewPage /> },
        { path: 'documents/purchaseReturn/verifyOut/:id', element: <PurchaseReturnVerifyOutPage /> },

        { path: 'documents/salesCreditNotes', element: <SalesCreditNotesPage /> },
        { path: 'documents/salesCreditNote/new', element: <SalesCreditNoteNewPage /> },
        { path: 'documents/salesCreditNote/update/:id', element: <SalesCreditNoteUpdatePage /> },
        { path: 'documents/salesCreditNote/view/:id', element: <SalesCreditNoteViewPage /> },
        { path: 'documents/salesCreditNote/verifyIn/:id', element: <SalesCreditNoteVerifyInPage /> },

        { path: 'documents/replacementDeliveries', element: <ReplacementDeliveriesPage /> },
        { path: 'documents/replacementDelivery/new', element: <ReplacementDeliveryNewPage /> },
        { path: 'documents/replacementDelivery/update/:id', element: <ReplacementDeliveryUpdatePage /> },
        { path: 'documents/replacementDelivery/view/:id', element: <ReplacementDeliveryViewPage /> },
        { path: 'documents/replacementDelivery/verifyOut/:id', element: <ReplacementDeliveryVerifyOutPage /> },

        { path: 'documents/itemRelocates', element: <ItemRelocatesPage /> },
        { path: 'documents/itemRelocate/new', element: <ItemRelocateNewPage /> },
        { path: 'documents/itemRelocate/view/:id', element: <ItemRelocateViewPage /> },
        { path: 'documents/itemRelocate/update/:id', element: <ItemRelocateUpdatePage /> },

        { path: 'documents/itemTransform', element: <ItemTransformPage /> },
        { path: 'documents/itemTransform/new', element: <ItemTransformNewPage /> },
        { path: 'documents/itemTransform/view/:id', element: <ItemTransformViewPage /> },

        { path: 'documents/purchaseInvoices', element: <PurchaseInvoicesPage /> },
        { path: 'documents/purchaseInvoice/new', element: <PurchaseInvoiceNewPage /> },
        { path: 'documents/purchaseInvoice/update/:id', element: <PurchaseInvoiceUpdatePage /> },
        { path: 'documents/purchaseInvoice/view/:id', element: <PurchaseInvoiceViewPage /> },

        { path: 'documents/itemIssues', element: <ItemIssuesPage /> },
        { path: 'documents/itemIssue/new', element: <ItemIssueNewPage /> },
        { path: 'documents/itemIssue/update/:id', element: <ItemIssueUpdatePage /> },
        { path: 'documents/itemIssue/view/:id', element: <ItemIssueViewPage /> },
        { path: 'documents/itemIssue/verifyOut/:id', element: <ItemIssueVerifyQutPage /> },

        { path: 'documents/itemAdjustments', element: <ItemAdjustmentsPage /> },
        { path: 'documents/itemAdjustment/new', element: <ItemAdjustmentNewPage /> },
        { path: 'documents/itemAdjustment/update/:id', element: <ItemAdjustmentUpdatePage /> },
        { path: 'documents/itemAdjustment/view/:id', element: <ItemAdjustmentViewPage /> },
        { path: 'documents/itemAdjustment/verifyIn/:id', element: <ItemAdjustmentVerifyInPage /> },
        { path: 'documents/itemAdjustment/verifyOut/:id', element: <ItemAdjustmentVerifyOutPage /> },

        { path: 'documents/stockTakes', element: <StockTakesPage /> },
        { path: 'documents/stockTake/new', element: <StockTakeNewPage /> },
        { path: 'documents/stockTake/update/:id', element: <StockTakeUpdatePage /> },
        { path: 'documents/stockTake/view/:id', element: <StockTakeViewPage /> },
        { path: 'documents/stockTake/execute/:id', element: <StockTakeExecutePage /> },

        { path: 'documents/transferReturns', element: <TransferReturnsPage /> },
        { path: 'documents/transferReturn/new', element: <TransferReturnNewPage /> },
        { path: 'documents/transferReturn/update/:id', element: <TransferReturnUpdatePage /> },
        { path: 'documents/transferReturn/view/:id', element: <TransferReturnViewPage /> },
        { path: 'documents/transferReturn/verifyTransferIn/:id', element: <TransferReturnVerifyTransferInPage /> },
        { path: 'documents/transferReturn/verifyOut/:id', element: <TransferReturnVerifyOutPage /> },

        { path: 'documents/transferRequisitions', element: <TransferRequisitionsPage /> },
        { path: 'documents/transferRequisition/new', element: <TransferRequisitionNewPage /> },
        { path: 'documents/transferRequisition/update/:id', element: <TransferRequisitionUpdatePage /> },
        { path: 'documents/transferRequisition/view/:id', element: <TransferRequisitionViewPage /> },

        { path: 'documents/salesInvoices', element: <SalesInvoicesPage /> },
        { path: 'documents/salesInvoice/new', element: <SalesInvoiceNewPage /> },
        { path: 'documents/salesInvoice/update/:id', element: <SalesInvoiceUpdatePage /> },
        { path: 'documents/salesInvoice/view/:id', element: <SalesInvoiceViewPage /> },

        { path: 'operations/inventory/examine', element: <ViewInventoryPage /> },
        { path: 'operations/itemThreshold/relocate', element: <ItemRelocateThresholdPage /> },
        { path: 'operations/itemThreshold/reorder', element: <ItemReorderThresholdPage /> },

        { path: 'reports/product/productItem', element: <ProductItemReport /> },
        { path: 'reports/sales/salesOrder', element: <SalesOrderReport /> },
        { path: 'reports/sales/salesOrderItem', element: <SalesOrderItemReport /> },
        { path: 'reports/sales/deliveryOrder', element: <DeliveryOrderReport /> },
        { path: 'reports/sales/deliveryOrderItem', element: <DeliveryOrderItemReport /> },
        { path: 'reports/warehouse/itemReceive', element: <ItemReceiveReport /> },
        { path: 'reports/warehouse/itemReceiveItem', element: <ItemReceiveItemReport /> },
        { path: 'reports/warehouse/itemTransfer', element: <ItemTransferReport /> },
        { path: 'reports/warehouse/itemTransferItem', element: <ItemTransferItemReport /> },
        { path: 'reports/inventory/stockValue', element: <StockValueReport /> },

        // { path: "reports/sales", element: <SalesReport /> },
        // {
        //     path: "reports/retailCashSales",
        //     element: <RetailCashSalesReport />
        // },
        // { path: "reports/delivery", element: <DeliveryReport /> },
        // {
        //     path: "reports/retailPrescription",
        //     element: <RetailPrescriptionReport />
        // },
        // { path: "reports/itemReceive", element: <ItemReceiveReport /> },

        { path: 'scheduler/tasks', element: <TasksPage /> },
        { path: 'scheduler/task/new', element: <TaskNewPage /> },
        { path: 'scheduler/task/update/:id', element: <TaskUpdatePage /> },

        { path: 'scheduler/logs', element: <LogsPage /> },
        { path: 'scheduler/log/view/:id', element: <LogViewPage /> },

        { path: 'scheduler/requests', element: <RequestsPage /> },
        { path: 'scheduler/request/view/:id', element: <RequestViewPage /> },

        { path: 'scheduler/console', element: <ConsolePage /> },

        { path: 'settings', element: <SettingsPage /> },
        { path: 'settings/userRoles', element: <UserRolesPage /> },
        { path: 'settings/userRole/new', element: <UserRoleNewPage /> },
        { path: 'settings/userRole/update/:id', element: <UserRoleUpdatePage /> },
        { path: 'settings/business', element: <BusinessPage /> },
        { path: 'settings/business/new', element: <BusinessNewPage /> },
        { path: 'settings/business/update/:id', element: <BusinessUpdatePage /> },
        // { path: 'settings/business', element: <BusinessViewPage /> },
        { path: 'settings/locations', element: <LocationsPage /> },
        { path: 'settings/location/new', element: <LocationNewPage /> },
        { path: 'settings/location/update/:id', element: <LocationUpdatePage /> },
        { path: 'settings/countries', element: <CountriesPage /> },
        { path: 'settings/country/update/:id', element: <CountryUpdatePage /> },
        { path: 'settings/customFields', element: <CustomFieldsPage /> },
        { path: 'settings/customField/new', element: <CustomFieldNewPage /> },
        { path: 'settings/customField/update/:id', element: <CustomFieldUpdatePage /> },
        { path: 'settings/shippingRates', element: <ShippingRatesPage /> },
        { path: 'settings/shippingRate/new', element: <ShippingRateNewPage /> },
        { path: 'settings/shippingRate/update/:id', element: <ShippingRateUpdatePage /> },
        { path: 'settings/shippingRules', element: <ShippingRulesPage /> },
        { path: 'settings/shippingRule/new', element: <ShippingRuleNewPage /> },
        { path: 'settings/shippingRule/update/:id', element: <ShippingRuleUpdatePage /> },
        { path: 'settings/taxRates', element: <TaxRatesPage /> },
        { path: 'settings/taxRate/new', element: <TaxRateNewPage /> },
        { path: 'settings/taxRate/update/:id', element: <TaxRateUpdatePage /> },
        { path: 'settings/auditTrails', element: <AuditTrailsPage /> },
        { path: 'settings/auditTrail/new', element: <AuditTrailNewPage /> },
        { path: 'settings/auditTrail/view/:id', element: <AuditTrailViewPage /> },
        { path: 'settings/auditTrail/tags', element: <AuditTrailTagsPage /> },
        { path: 'settings/injectionProps', element: <InjectionPropsPage /> },
        { path: 'settings/injectionProp/new', element: <InjectionPropNewPage /> },

        { path: 'settings/injectionFields', element: <InjectionFieldsPage /> },
        { path: 'settings/injectionField/new', element: <InjectionFieldNewPage /> },

        { path: 'settings/emailGateway', element: <EmailGatewayPage /> },
        { path: 'settings/whatsapp', element: <WhatsAppPage /> },
        { path: 'settings/sms', element: <SMSPage /> },
        { path: 'settings/wallets', element: <WalletsPage /> },
        { path: 'settings/wallet/new', element: <WalletNewPage /> },
        { path: 'settings/wallet/update/:id', element: <WalletUpdatePage /> },
        { path: 'settings/walletUsers', element: <WalletUsersPage /> },
        { path: 'settings/schedulers', element: <TasksPage /> },
        { path: 'settings/scheduler/task/new', element: <TaskNewPage /> },
        { path: 'settings/scheduler/task/update/:id', element: <TaskUpdatePage /> },
        { path: 'settings/scheduler/logs', element: <LogsPage /> },
        { path: 'settings/scheduler/log/view/:id', element: <LogViewPage /> },
        { path: 'settings/scheduler/requests', element: <RequestsPage /> },
        { path: 'settings/scheduler/request/view/:id', element: <RequestViewPage /> },
        { path: 'settings/scheduler/console', element: <ConsolePage /> },

        { path: 'transactions/walletRequests', element: <WalletRequestsPage /> },
        { path: 'transactions/walletRequest/new', element: <WalletRequestNewPage /> },
        { path: 'transactions/walletRequest/update/:id', element: <WalletRequestUpdatePage /> },

        { path: 'transactions/walletTransactions', element: <WalletTransactionsPage /> },

        { path: 'settings/userApiKeys', element: <UserApiKeysPage /> },
        { path: 'settings/userApiKey/update/:id', element: <UserApiKeyUpdatePage /> },
        { path: 'settings/userApiKey/new', element: <UserApiKeyNewPage /> },

        // { path: 'settings/wallets/view/:id', element:
        // <WalletViewPage /> },
      ],
    },
  ];
}
